
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 140.22 120.9"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Training"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M140.22 0H0v107.58h95A59.7 59.7 0 0191.43 118a.47.47 0 01.15.06 57.22 57.22 0 008.56-7.29 55.61 55.61 0 014.58 10.17 70.54 70.54 0 004-13.32h5.13a51.24 51.24 0 011 8.39h.15a52.63 52.63 0 004-8.39h2.76a60.61 60.61 0 016.47 5.83c-.14-2-.38-3.93-.69-5.83h12.74zm-31.28 106.18c.12-.7.2-1.4.29-2.1H113q.3 1 .54 2.1zm.76-7.7v-2.6c.44.85.86 1.72 1.24 2.6zm9.76 7.7a1.8 1.8 0 00.08-.21l.28.21zm-5.75-27.82l7.56.83-6.07-4.86 7.69-1.18-7.12-3.15 7.12-3.13-7.69-1.18 6.07-4.86-7.73.85 4.6-6.27-7.25 2.82 2.82-7.23-6.26 4.6.85-7.73-4.87 6.06-1.18-7.68-3.12 7.12L96 46.26l-1.18 7.68L90 47.88l.84 7.73-6.3-4.61 2.82 7.24-7.25-2.82 4.6 6.27-7.71-.84 6.07 4.86-7.69 1.18L82.49 70l-7.13 3.13 7.69 1.18L77 79.19l7.73-.85-4.6 6.27 7.25-2.82L84.54 89l6.26-4.6-.8 7.76 4.86-6.06L96 93.78l.13-.3a41.69 41.69 0 01.09 5H9.1V9.1h122v89.38h-5.79a56.64 56.64 0 00-11.6-20.12zm25.11 27.82h-11.55c-.13-.71-.29-1.41-.45-2.1h9.89V3.5H3.5v100.58h92.15c-.11.69-.23 1.4-.37 2.1H1.4V1.4h137.42z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M121.68 20.46H18.88a.7.7 0 000 1.4h102.8a.7.7 0 100-1.4zM121.68 31H18.88a.7.7 0 000 1.4h102.8a.7.7 0 100-1.4zM65.73 86.89H18.88a.7.7 0 100 1.4h46.85a.7.7 0 100-1.4z"}})])])])
          )
        }
      }
    